module.exports = __webpack_public_path__ + "img/user.f3f87ce3.svg";